import { Box, Button, Stat, StatLabel, StatNumber, Skeleton } from "@chakra-ui/react"
import React, { useEffect, useContext } from "react"
import { useQuery } from "@apollo/react-hooks"
import { SELLER_DETAILS } from "../../graphql/queries"
import { DomainContext } from "../context/DomainContext"
import { ProgressDispatchContext } from "../context/ContextProvider"
import Link from "next/link"
import { arrayFilter, replaceUrlString, nullValidations } from "../../utils/Utils"

export default function StatsBox(props) {
  const { sellerId, code, openInNewTab } = props
  const domainContextVal = useContext(DomainContext)
  const setProgressStatus = useContext(ProgressDispatchContext)
  const { data, loading } = useQuery(
    SELLER_DETAILS, {
    variables: {
      domainCode: code,
      sellerId: sellerId
    }
  }
  )

  useEffect(() => {
    if (loading === false && data) {
      setProgressStatus({ status: false })
    } else {
      setProgressStatus({ status: true })
    }
  }, [loading, data])

  return (
    <>
      <Box w="100%">
        <Stat>
          <StatNumber color="#243e63" fontSize="16px" pb={{ base: 1.5, md: 1.5, lg: 3 }} fontWeight="600">Seller Name</StatNumber>
          <Skeleton isLoaded={!loading} height={loading ? 3 : "auto"}>
            <StatLabel color="#243e63" fontSize="14" fontWeight="500">{nullValidations(data?.seller?.name)}</StatLabel>
          </Skeleton>
        </Stat>
      </Box>
      <Box w="100%">
        <Stat>
          <StatNumber color="#243e63" fontSize="16px" pb={{ base: 1.5, md: 1.5, lg: 3 }} fontWeight="600">Marketplace</StatNumber>
          <Skeleton isLoaded={!loading} height={loading ? 3 : "auto"}>
            <StatLabel color="#243e63" fontSize="14" fontWeight="500">{nullValidations(data?.seller?.domain?.name)}</StatLabel>
          </Skeleton>
        </Stat>
      </Box>
      <Box w="100%">
        <Stat>
          <StatNumber color="#243e63" fontSize="16px" pb={{ base: 1.5, md: 1.5, lg: 3 }} fontWeight="600">FBA Seller?</StatNumber>
          <Skeleton isLoaded={!loading} height={loading ? 3 : "auto"}>
            <StatLabel color="#243e63" fontSize="14" fontWeight="500" >{data?.seller?.hasFba ? "Yes" : "No"}</StatLabel>
          </Skeleton>
        </Stat>
      </Box>
      <Box w="100%">
        <Stat>
          <StatNumber color="#243e63" fontSize="16px" pb={{ base: 1.5, md: 1.5, lg: 3 }} fontWeight="600">Top Categories</StatNumber>
          <Skeleton isLoaded={!loading} height={loading ? 3 : "auto"}>
            <StatLabel color="#243e63" fontSize="14" fontWeight="500">
              {arrayFilter(data?.seller?.categories, "category", "desc")?.map((x, y) => {
                if (y > 0) {
                  return `, ${x?.name}`
                } else {
                  return x?.name
                }
              })}
            </StatLabel>
          </Skeleton>
        </Stat>
      </Box>
      <Box w="100%">
        <Stat>
          <StatNumber color="#243e63" fontSize="16px" pb={{ base: 1.5, md: 1.5, lg: 3 }} fontWeight="600">Top Brands</StatNumber>
          <Skeleton isLoaded={!loading} height={loading ? 3 : "auto"}>
            <StatLabel color="#243e63" fontSize="14" fontWeight="500">{arrayFilter(data?.seller?.brands, "brand", "desc")}</StatLabel>
          </Skeleton>
        </Stat>
      </Box>
      <Box w="100%">
        <Stat>
          <StatNumber color="#243e63" fontSize="16px" pb={{ base: 1.5, md: 1.5, lg: 3 }} fontWeight="600">Location</StatNumber>
          <Skeleton isLoaded={!loading} height={loading ? 3 : "auto"}>
            <StatLabel color="#243e63" fontSize="14" fontWeight="500">{data?.seller?.info?.state ? `${data?.seller?.info?.state}, ` : ""} {data?.seller?.info?.country?.name ? data?.seller?.info?.country?.name : ""} </StatLabel>
          </Skeleton>
        </Stat>
      </Box>
      <Box w="100%">
        <Stat>
          <StatNumber color="#243e63" fontSize="16px" pb={{ base: 1.5, md: 1.5, lg: 3 }} fontWeight="600">Reviews (last 12m)</StatNumber>
          <Skeleton isLoaded={!loading} height={loading ? 3 : "auto"}>
            <StatLabel color="#243e63" fontSize="14" fontWeight="500">{nullValidations(data?.seller?.stats?.reviews12m)?.toLocaleString()}</StatLabel>
          </Skeleton>
        </Stat>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems={{ base: "flex-start", md: "flex-start", lg: "flex-end" }}
        flexDirection="column"
        p={"1rem 0rem"}
        mt={{ base: "0", md: "10", lg: "10" }}
      >
        <Link href={{ pathname: "/sellers/" + code + "/" + sellerId + "/" + replaceUrlString(data?.seller?.name) }} passHref>
          <a target={openInNewTab === true ? "_blank" : "_self"} rel={"noopener noreferrer"}>
            <Button
              _hover={{
                bg: "#f05605"
              }}
              bg="#f05605"
              color="#fff"
              fontSize="0.875rem"
              variant="no-hover"
              fontWeight="400"
              border-color="#f05605"
              padding="0.5rem 1.2rem"
              isDisabled={!loading ? false : true}
            >
              Seller Dashboard
            </Button>
          </a>
        </Link>
      </Box>
    </>
  )
}
